/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SubjectWalletResult { 
    /**
     * The descentralized identification of the subject. It is a type of identifier that allows the verification of decentralized identities. Format: \'did : ala : network (specifies the technology used on that network) : net-id (defines the specific blockchain network instance) : address (of the proxy smart contract generated in de create identity process)\'. \'did:ala:quor:redT:01edb987f7841117e558626577e51c68467b97f1\', for example.
     */
    did?: string;
    /**
     * The wallet created for the subject. Contains all the needed information to interact with blockchain. Encoded in Base64 format
     */
    wallet?: SubjectWalletResult.WalletEnum;
    /**
     * The PKCS#12 created for the subject. Contains all the needed information to interact with JWT. Encoded in Base64 format
     */
    pkcs12?: SubjectWalletResult.Pkcs12Enum;
}
export namespace SubjectWalletResult {
    export const WalletEnum = {
        B1abfe081: '[B@1abfe081'
    } as const;
    export type WalletEnum = typeof WalletEnum[keyof typeof WalletEnum];
    export const Pkcs12Enum = {
        B2a685eba: '[B@2a685eba'
    } as const;
    export type Pkcs12Enum = typeof Pkcs12Enum[keyof typeof Pkcs12Enum];
}


